import { type Currency, svgIconDataUri } from "@loot-os/api-contract";

import { cn } from "../foundations/cn.js";
import { useCurrency } from "./currencyContext.js";

export interface CurrencyMarkProps {
  /** Overrides the CurrencyProvider's currency. */
  currency?: Currency;
  /**
   * Where the currency has no icon: its `symbol` ("$"), or `none` for an amount's mark, whose
   * formatted text already carries the symbol.
   */
  noIcon?: "symbol" | "none";
  className?: string;
}

/**
 * The store's currency as a mark: its icon, or its symbol where it has none ("$"). Drawing only,
 * for a control about money (a price filter); an amount is an `Amount`.
 */
export function CurrencyMark({ currency, noIcon = "symbol", className }: CurrencyMarkProps) {
  const fromContext = useCurrency();
  const unit = currency ?? fromContext;
  if (unit.iconSvg)
    return (
      <img
        src={svgIconDataUri(unit.iconSvg)}
        alt=""
        aria-hidden
        className={cn("size-4 shrink-0", className)}
      />
    );
  if (noIcon === "none") return null;
  return (
    <span aria-hidden className={cn("font-mono text-mono-price", className)}>
      {unit.symbol}
    </span>
  );
}
